// src/components/store/sections/gallery/GalleryV40PolaroidwallIndigoPulse.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV40PolaroidwallIndigoPulse(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={40}
      archKey="polaroid_wall"
      archLabel="Polaroid Washi Wall"
      palName="IndigoPulse"
      grad="from-indigo-500 via-blue-600 to-violet-700"
      lightBg="bg-indigo-50"
      textCol="text-indigo-700"
      borderCol="border-indigo-200"
      btnCls="bg-indigo-600 hover:bg-indigo-700"
      hexCol="#6366f1"
      {...props}
    />
  );
}
